namespace RioERP.Carts {
    export interface CartProductSpecificationsForm {
        CartId: Serenity.IntegerEditor;
        CartProductsId: Serenity.IntegerEditor;
        ProductSpecificationId: Serenity.IntegerEditor;
        InsertUserId: Serenity.IntegerEditor;
        InsertDate: Serenity.DateEditor;
        UpdateUserId: Serenity.IntegerEditor;
        UpdateDate: Serenity.DateEditor;
        IsActive: Serenity.BooleanEditor;
    }

    export class CartProductSpecificationsForm extends Serenity.PrefixedContext {
        static formKey = 'Carts.CartProductSpecifications';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CartProductSpecificationsForm.init)  {
                CartProductSpecificationsForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.DateEditor;
                var w2 = s.BooleanEditor;

                Q.initFormType(CartProductSpecificationsForm, [
                    'CartId', w0,
                    'CartProductsId', w0,
                    'ProductSpecificationId', w0,
                    'InsertUserId', w0,
                    'InsertDate', w1,
                    'UpdateUserId', w0,
                    'UpdateDate', w1,
                    'IsActive', w2
                ]);
            }
        }
    }
}
